import * as React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {Asset} from '@deviceinsight/ng-ui-api-client';
import {DeviceElement} from '../../../modules/ruleengine/types';
import {getAvailableElements} from '../ruleEditHelpers';
import TranslatedOption from '../../common/TranslatedOption';

type Props = {
	asset: Asset | null | undefined;
	onElementSelect: (element?: DeviceElement) => void;
	selectedElement: DeviceElement | null | undefined;
	canEdit: boolean;
};

const ConditionElement = ({asset, onElementSelect, selectedElement, canEdit}: Props) => {
	if (asset) {
		const availableElements = getAvailableElements(asset);
		const selectedItemKey = selectedElement ? selectedElement.key : undefined;
		return (
			<div className="rule-element">
				<select
					data-testid="rule-element-select"
					onChange={({target: {value}}) =>
						onElementSelect(availableElements.find((element) => element.key === value))
					}
					value={selectedItemKey || ''}
					disabled={!canEdit}>
					{!selectedItemKey && (
						<TranslatedOption
							trans={{
								id: `ruleengine.element.select.element`,
								defaultValue: `Please select...`
							}}
							value=""
						/>
					)}
					{availableElements.map((element) => (
						<TranslatedOption
							key={element.key}
							trans={{
								id: `${element.labelId}`,
								defaultValue: `${element.defaultLabel}`
							}}
							value={element.key}
						/>
					))}
				</select>
			</div>
		);
	} else {
		return (
			<div>
				<Trans i18nKey="ruleengine.element.select.asset">Please select device first...</Trans>
			</div>
		);
	}
};

export default ConditionElement;
